import { Component } from 'react';
import { isGranted } from 'helpers/helpers';
import {
  ROLE_CREATE_NOTE,
  ROLE_EDIT_NOTE,
  ROLE_REMOVE_NOTE,
  ROLE_SHOW_NOTE,
} from 'helpers/roles';
import { post, get } from 'helpers/apiHelpers';
import ModalButton from 'components/CustomButtons/Button';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import FormTextInput from 'components/FormTextInput/FormTextInput';
import DataGrid from 'components/DataGrid/DataGrid';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Close from '@material-ui/icons/Close';
import { toast } from 'react-toastify';

import notesColumnConfig from './notesColumnConfig';
import { orderStyles } from '../../styles';

class NotesModal extends Component {
  state = {
    content: '',
    editModalData: {},
  };

  // eslint-disable-next-line consistent-return -- FIXME
  addNote = e => {
    const { t } = this.props;

    if (!this.state.content || this.state.content.trim().length === 0) {
      return toast.error(t('errors.contentRequired'));
    }

    e.preventDefault();
    post('/notes', {
      content: this.state.content,
      key: this.props.client['@id'],
      // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    }).then(() => {
      this.setState({ content: '' });
      this.closeModal();
      toast.success(t('success.noteAdded'));
    });
  };

  closeModal = () => {
    // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
    get('notes', { key: this.props.client['@id'] }).then(notes => {
      this.props.setNotes(notes['hydra:member']);
      this.props.setNotesModalStatus(false);
      this.setState({ content: '' });
    });
  };

  render() {
    const { classes, notesModalStatus, t } = this.props;

    return (
      <Dialog
        maxWidth="lg"
        fullWidth={true}
        open={notesModalStatus}
        onClose={() => this.closeModal()}
      >
        <DialogContent>
          <ModalButton
            style={orderStyles.closeButton}
            color="transparent"
            justIcon={true}
            round={true}
            onClick={() => this.closeModal()}
          >
            <Close />
          </ModalButton>
          <GridContainer>
            {isGranted(ROLE_CREATE_NOTE) && (
              <GridItem md={isGranted(ROLE_SHOW_NOTE) ? 3 : 12}>
                <div style={{ marginLeft: '5px', ...orderStyles.box }}>
                  <b>{t('notes.newNote', 'Nowa notatka')}</b>
                  <FormTextInput
                    multiline={true}
                    rowsMax={10}
                    label={t('notes.noteContent', 'Treść notatki')}
                    classes={classes}
                    name="phone"
                    value={this.state.content}
                    handleChange={ev =>
                      this.setState({ content: ev.target.value })
                    }
                    inputSize={12}
                    maxLength={400}
                  />
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <ModalButton
                      color="primary"
                      onClick={ev => this.addNote(ev)}
                    >
                      {t('notes.addNote', 'Dodaj notatkę')}
                    </ModalButton>
                  </div>
                </div>
              </GridItem>
            )}
            {isGranted(ROLE_SHOW_NOTE) && (
              <GridItem md={isGranted(ROLE_CREATE_NOTE) ? 9 : 12}>
                <div
                  style={{
                    marginLeft: '5px',
                    ...orderStyles.box,
                    paddingBottom: '10px',
                  }}
                >
                  <b>{t('notes.allNotes', 'Wszystkie notatki')}</b>
                </div>
                <DataGrid
                  hideArchive={true}
                  refreshOnFetch={true}
                  actions={true}
                  remove={true}
                  // eslint-disable-next-line require-await -- FIXME
                  editAction={async row => {
                    this.props.setNotesModalStatus(false);
                    this.props.setEditModalStatus(true);
                    this.props.setEditModalData(row);
                  }}
                  paginationTop={false}
                  paginationBottom={false}
                  url="notes"
                  reportName="notes"
                  query={this.props.client['@id']}
                  columns={notesColumnConfig}
                  role="NOTE"
                  hasRoleToModifyNotes={
                    isGranted(ROLE_EDIT_NOTE) && isGranted(ROLE_REMOVE_NOTE)
                  }
                />
              </GridItem>
            )}
          </GridContainer>
        </DialogContent>
      </Dialog>
    );
  }
}

export default NotesModal;
